import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

/**
 * MFE style isolation (Connect/mf-hr-root, Leaves/mf-hl-root, etc.):
 *
 * Angular CDK's `OverlayContainer` is `providedIn: 'root'`, so each bootstrapped
 * Angular application (the shell AND every Module Federation MFE) gets its OWN
 * instance and therefore its OWN `<div class="cdk-overlay-container">` appended
 * to `document.body` — even though they share the same document.
 *
 * This subclass tags the shell's own container with `data-shell-overlay` so that
 * global shell styles targeting CDK overlay-based components (mat-dialog,
 * mat-menu, mat-select panel, mat-autocomplete panel, mat-datepicker calendar,
 * mat-bottom-sheet, mat-snack-bar) can be scoped to
 * `.cdk-overlay-container[data-shell-overlay] ...` and never bleed into an MFE's
 * own overlay container, which will not carry this attribute.
 *
 * See docs/mdc-audit-report.md for the full investigation.
 */
@Injectable()
export class ShellOverlayContainer extends OverlayContainer {
  override getContainerElement(): HTMLElement {
    const element = super.getContainerElement();
    if (!element.hasAttribute('data-shell-overlay')) {
      element.setAttribute('data-shell-overlay', '');
    }
    return element;
  }
}
